export default __webpack_public_path__ + "static/1inch_test-35272d8e1d5e9a5c178e6d451fb25426.svg";